import { Injectable } from '@angular/core';
import { Observable, of, EMPTY } from 'rxjs';

import { RequestResponse, ResponseState } from '@shure/shared/angular/data-access/system-api/models';

import { RoomAdaptApiService, RoomAdaptDevice, RoomAdaptRoomDevice } from '../api';

@Injectable()
export class NoopRoomAdaptApiService extends RoomAdaptApiService {
	public getDevice$(_deviceId: string): Observable<RoomAdaptDevice> {
		return EMPTY;
	}

	public getDevicesInRoom$(_roomId: string): Observable<RoomAdaptRoomDevice[]> {
		return of([]);
	}

	public getAllRoomAdaptDeviceIds$(): Observable<string[]> {
		return of([]);
	}

	public startRoomAdapt(_deviceId: string): Observable<RequestResponse<string>> {
		return of({ state: ResponseState.Error, value: '' });
	}

	public abortRoomAdapt(_deviceId: string): Observable<RequestResponse<string>> {
		return of({ state: ResponseState.Error, value: '' });
	}

	public retrieveRoomCharacterizationReport(_deviceId: string): Observable<string | null> {
		return of(null);
	}

	public getDeviceNames$(_ids: string[]): Observable<Record<string, string>> {
		return of({});
	}
}
